
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 300 300","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"1.5"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","d":"M0 0h300v300H0z"}}),_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"d":"M0 0h300v300H0z"}})]),_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('path',{attrs:{"d":"M0 0l300 300V0H0z","fill":"url(#_Linear2)"}}),_c('g',{attrs:{"fill":"none","stroke":"#fff","stroke-width":"5.83"}},[_c('path',{attrs:{"d":"M177.058 33.587l94.057 94.057M246.67 121.202h-61.882c-19.2 0-34.788-15.588-34.788-34.789 0-16.805 11.943-30.844 27.797-34.084M197.012 38.754A41.015 41.015 0 01217 33.587c19.208 0 35.365 13.162 39.937 30.951C271.987 65.21 284 77.641 284 92.856c0 8.978-4.183 16.986-10.705 22.182"}})])]),_c('defs',[_c('linearGradient',{attrs:{"id":"_Linear2","x1":"0","y1":"0","x2":"1","y2":"0","gradientUnits":"userSpaceOnUse","gradientTransform":"matrix(300 0 0 300 0 150)"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#f24f36"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#d12034"}})])])])
          )
        }
      }
    